module.exports = __webpack_public_path__ + "static/milpitas-16936eced51e28ce2255b38e9b19ce3e.jpg";